import { LazyImageWithSkeleton } from "./LazyImageWithSkeleton";

// ---------------- FBT ----------------
export const FBTTemplateInfo = [
    {
        label: "Amazon Style",
        template: "horizontal",
        icon: <LazyImageWithSkeleton src="/svgs/HorizontalFBT.svg" alt="FBT Horizontal" />,
        hoverText: "Will render below Shopify Section",
    },
    {
        label: "Vertical",
        template: "vertical",
        icon: <LazyImageWithSkeleton src="/svgs/VerticalFBT.svg" alt="FBT Vertical" />,
        hoverText: "Will render below Add To Cart",
    },
];

// ---------------- Standard ----------------
export const StandardTemplateInfo = [
    {
        label: "Vertical Basic",
        template: "vertical_basic",
        icon: <LazyImageWithSkeleton src="/svgs/StandardVerticalBasic.png" alt="Standard Vertical Basic" />,
        // hoverText: "Standard vertical layout",
    },
    {
        label: "Vertical Classic",
        template: "vertical_classic",
        icon: <LazyImageWithSkeleton src="/svgs/StandardVerticalClassic.png" alt="Standard Vertical Classic" />,
        // hoverText: "Classic vertical layout",
    },
    {
        label: "Horizontal Basic",
        template: "horizontal_basic",
        icon: <LazyImageWithSkeleton src="/svgs/StandardHorizontalBasic.png" alt="Standard Horizontal Basic" />,
        // hoverText: "Standard horizontal layout",
    },
];

// ---------------- Volume ----------------
export const VolumeTemplateInfo = [
    {
        label: "Vertical Basic",
        template: "vertical_basic",
        icon: (
            <LazyImageWithSkeleton
                src="/svgs/VolumeVerticalBasic.svg
    "
                alt="Volume Vertical Basic"
            />
        ),
        // hoverText: "Basic vertical layout",
    },

    {
        label: "Vertical Classic",
        template: "vertical_classic",
        icon: (
            <LazyImageWithSkeleton
                src="/svgs/VolumeVerticalClassic.svg
    "
                alt="Volume Vertical Classic"
            />
        ),
        // hoverText: "Classic vertical layout",
    },
    {
        label: "Vertical Modern",
        template: "vertical_modern",
        icon: (
            <LazyImageWithSkeleton
                src="/svgs/VolumeVerticalModern.svg
    "
                alt="Volume Vertical Modern"
            />
        ),
        // hoverText: "Modern vertical layout",
    },
    {
        label: "Horizontal Basic",
        template: "horizontal_basic",
        icon: (
            <LazyImageWithSkeleton
                src="/svgs/VolumeHorizontalBasic.svg
    "
                alt="Volume Horizontal Basic"
            />
        ),
        // hoverText: "Volume bundle horizontal layout",
    },
    {
        label: "Horizontal Modern",
        template: "horizontal_modern",
        icon: (
            <LazyImageWithSkeleton
                src="/svgs/VolumeHorizontalModern.svg
    "
                alt="Volume Horizontal Modern"
            />
        ),
        // hoverText: "Modern horizontal layout",
    },
];

// ---------------- BXGY ----------------
export const BXGYTemplateInfo = [
    {
        label: "Horizontal Basic",
        template: "horizontal_basic",
        icon: (
            <LazyImageWithSkeleton
                src="/svgs/BXGYHorizontalBasic.svg
    "
                alt="BXGY Horizontal Basic"
            />
        ),
        // hoverText: "BXGY horizontal layout",
    },
    {
        label: "Vertical Classic",
        template: "vertical_classic",
        icon: (
            <LazyImageWithSkeleton
                src="/svgs/BXGYVerticalClassic.svg
    "
                alt="BXGY Vertical Classic"
            />
        ),
        // hoverText: "BXGY vertical layout",
    },
];

export const BBTemplateInfo = [
    {
        label: "Classic",
        template: "full_card_info",
        icon: <LazyImageWithSkeleton src="/svgs/BBClassic.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["Tiered Discount", "Multi-Step"],
        desc: "Shows product title and product price",
    },
    {
        label: "Minimal",
        template: "basic_card_info",
        icon: <LazyImageWithSkeleton src="/svgs/BBMinimal.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["Fixed Price Bundle", "Products with Multiple Variants"],
        desc: "Strips out prices for a cleaner look. Perfect for bundles with one flat rate.",
    },
    {
        label: "Visual Focus",
        template: "img_focus_card",
        icon: <LazyImageWithSkeleton src="/svgs/BBVisualFocus.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["Fixed Price Bundle", "Aesthetic Bundles"],
        desc: "Designed for impact. Lets your product images take center stage, creating a modern, gallery-style shopping feel.",
    },
    {
        label: "Interactive",
        template: "hover_action_card",
        icon: <LazyImageWithSkeleton src="/svgs/BBInteractive.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["% or fixed discounts", "Products with Multiple Variants"],
        desc: "Your products stay front and center with titles and prices visible, the Add to Box button glides on hover.",
    },
    {
        label: "Hover Minimal",
        template: "hover_info_card",
        icon: <LazyImageWithSkeleton src="/svgs/BBHoverMinimal.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["Fixed Price Bundle", "Multi-Step"],
        desc: "Elegant and restrained. Keeps the title visible and hides the price, with the Add to Box button appearing as customers hover.",
    },
];

export const BBTemplateInfoRightFooter = [
    {
        label: "Classic",
        template: "full_card_info",
        icon: <LazyImageWithSkeleton src="/svgs/BBRightClassic.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["Tiered Discount", "Multi-Step"],
        desc: "Shows product title and product price",
    },
    {
        label: "Minimal",
        template: "basic_card_info",
        icon: <LazyImageWithSkeleton src="/svgs/BBRightMinimal.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["Fixed Price Bundle", "Products with Multiple Variants"],
        desc: "Strips out prices for a cleaner look. Perfect for bundles with one flat rate.",
    },
    {
        label: "Visual Focus",
        template: "img_focus_card",
        icon: <LazyImageWithSkeleton src="/svgs/BBRightVisualFocus.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["Fixed Price Bundle", "Aesthetic Bundles"],
        desc: "Designed for impact. Lets your product images take center stage, creating a modern, gallery-style shopping feel.",
    },
    {
        label: "Interactive",
        template: "hover_action_card",
        icon: <LazyImageWithSkeleton src="/svgs/BBRightInteractive.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["% or Fixed Discounts", "Products with Multiple Variants"],
        desc: "Your products stay front and center with titles and prices visible , the Add to Box button glides on hover.",
    },
    {
        label: "Hover Minimal",
        template: "hover_info_card",
        icon: <LazyImageWithSkeleton src="/svgs/BBRightHoverMinimal.png" alt="BB" enableZoom zoomScale={1.8} />,
        tags: ["Fixed Price Bundle", "Multi-Step"],
        desc: "Elegant and restrained. Keeps the title visible and hides the price, with the Add to Box button appearing as customers hover.",
    },
];

export const BBFooterTemplateInfo = [
    {
        label: "Bottom Footer",
        template: "bottom",
        icon: <LazyImageWithSkeleton src="/svgs/BBFooterTemplate.svg" alt="BB" />,
    },
    {
        label: "Right Footer",
        template: "right",
        icon: <LazyImageWithSkeleton src="/svgs/BBSideBarTemplate.svg" alt="BB" />,
    },
];

export const PlaceholderTemplateInfo = [
    {
        label: "Quick Pick",
        template: "normal",
        icon: <LazyImageWithSkeleton src="/svgs/PBQuickPick.png" alt="Quick Pick" enableZoom zoomScale={1.8} />,
        desc: "Keep your product page clean while shoppers browse products inside an interactive popup drawer.",
    },
    {
        label: "Showcase Grid",
        template: "accordian",
        icon: <LazyImageWithSkeleton src="/svgs/PBShowcaseGrid.png" alt="Showcase Grid" enableZoom zoomScale={1.8} />,
        desc: "Display products directly inside the bundle widget for faster browsing and higher visibility.",
    },
];
